<template>
    <div
        id="app"
        :class="[
            'bg-base-200',
            {
                'listener-mobile-mode': isListenerMobile,
                'listener-now-playing-mode': isListenerNowPlaying
            }
        ]"
    >
        <meta name="referrer" content="no-referrer">
        <meta name="mobile-web-app-capable" content="yes">
        <meta name="apple-mobile-web-app-capable" content="yes">
        <meta name="apple-mobile-web-app-status-bar-style" content="black">
        <!-- <link href="./output.css" rel="stylesheet"> -->
        <magic-menu v-if="$route.name !== 'login'"></magic-menu>
        <floating-ai-chat-launcher v-if="$route.name !== 'login'"></floating-ai-chat-launcher>
        <div v-else>
            <login></login>
        </div>
    </div>
</template>

<script>
import magicMenu from '@/components/base/magicMenu'
import Login from '@/views/user/login'
import { getApiBaseUrl, isAppMode } from '@/utils/apiConfig'
// 动态导入stagewise依赖，避免在生产环境中打包

export default {
    name: 'app',
    components: {
        magicMenu,
        FloatingAiChatLauncher: () => import('@/components/opencode/FloatingAiChatLauncher.vue'),
        Login
    },
    data() {
        return {
            menuList: [],
            StagewiseToolbar: null,
            stagewiseConfig: null
        }
    },
    computed: {
        isDevelopment() {
            return process.env.NODE_ENV === 'development'
        },
        isListenerMobile() {
            return !this.$store.state.common.isSuperuser
                && this.$route.name !== 'login'
                && typeof window !== 'undefined'
                && window.innerWidth <= 768
        },
        isListenerNowPlaying() {
            return this.isListenerMobile && this.$route.name === 'playingList'
        }
    },
    watch: {
        isListenerNowPlaying: {
            immediate: true,
            handler(value) {
                this.syncNowPlayingPageState(value)
            }
        },
        isListenerMobile: {
            immediate: true,
            handler(value) {
                this.syncListenerMobileShellState(value)
            }
        }
    },
    async mounted() {
        try {
            await this.$store.dispatch('initializePlayer')
        } catch (error) {
            console.warn('初始化播放器失败:', error)
        }
    },
    created() {
        // todo test
        window.projectVersion = '20261010'
        window.projectVersionNum = '2.8.0'

        // 应用模式下检查服务器地址配置
        if (isAppMode()) {
            const apiBaseUrl = getApiBaseUrl()
            console.log('App 模式启动, API 地址:', apiBaseUrl)

            // 如果没有配置服务器地址,跳转到登录页
            if (!apiBaseUrl && this.$route.name !== 'login') {
                console.log('未配置服务器地址,跳转到登录页')
                this.$router.push({ name: 'login' })
            }
        }
    },
    beforeDestroy() {
        this.syncListenerMobileShellState(false)
        this.syncNowPlayingPageState(false)
    },
    methods: {
        syncListenerMobileShellState(enabled) {
            if (typeof document === 'undefined') return
            document.body.classList.toggle('listener-mobile-shell-page', enabled)
        },
        syncNowPlayingPageState(enabled) {
            if (typeof document === 'undefined') return
            const html = document.documentElement
            const body = document.body
            html.classList.toggle('listener-now-playing-page', enabled)
            body.classList.toggle('listener-now-playing-page', enabled)
        }
    }
}
</script>
<style>
html.listener-now-playing-page,
body.listener-now-playing-page {
    height: 100dvh;
    overflow: hidden;
}

body.listener-now-playing-page {
    padding-bottom: 0 !important;
}

body.listener-mobile-shell-page {
    padding-bottom: 0 !important;
}

#app.listener-now-playing-mode {
    height: 100dvh;
    overflow: hidden;
}

.toggle:checked {
    @apply shadow-lg;
}
:root,
:root * {
    scrollbar-width: none;
    -ms-overflow-style: none;
}

:root::-webkit-scrollbar,
:root *::-webkit-scrollbar {
    display: none !important;
    width: 0;
    height: 0;
}

.h-screen-header {
    height: calc(100vh - 85px);
}

.h-screen-index {
    height: calc(100vh - 70px);
}

.h-screen-header-tree {
    height: calc(100vh - 88px);
}

@media (max-width: 768px) {
    .h-screen-header {
        height: calc(100vh - 60px);
    }
    .h-screen-index {
    height: calc(100vh - 60px);
    }
    .h-screen-header-tree {
        height: calc(100vh - 60px);
    }
}

.listener-mobile-mode .h-screen-header {
    height: calc(100vh - 190px);
}

.listener-mobile-mode .h-screen-index {
    height: auto;
    min-height: calc(100vh - 60px);
}




.w-screen-sidebar {
    width: calc(100vw - 240px);
}

.drawer-side {
    /* 抽屉需要覆盖桌面顶部导航栏（z-index: 80） */
    z-index: 100 !important;
}
</style>
